module.exports = __webpack_public_path__ + "media/images/icons/clock-cba7a017c46ffe27aad6adffe71789a2.svg";